import { render, staticRenderFns } from "./CatelogueManage.vue?vue&type=template&id=3755b8d8&scoped=true"
import script from "./CatelogueManage.vue?vue&type=script&lang=js"
export * from "./CatelogueManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3755b8d8",
  null
  
)

export default component.exports